export default {
    monitor: {name: "Monitor"},
    keyboard: {name: "Keyboard"},
    mouse: {name: "Mouse"},
    webcam: {name: "Webcam"},
    headset: {name: "Headset"},
    dockingStation: {name: "Docking Station"},
}